import './Gradient.scss';

const Gradient = () => {
  return <div className="gradient"></div>;
};

export default Gradient;
